import React, { useState } from "react";

export default function DateSelector({ dateRange, setDateRange }) {
  const [localRange, setLocalRange] = useState(dateRange);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setLocalRange({
      ...localRange,
      [id === "start-date" ? "start" : "end"]: value,
    });
  };

  const handleApply = () => {
    setDateRange(localRange);
  };

  return (
    <div className='d-flex gap-2 '>
      <div className='d-flex align-items-center gap-2'>
        <label htmlFor='start-date' className='form-label mb-1'>
          From:
        </label>
        <input
          type='date'
          id='start-date'
          className='form-control'
          value={localRange.start}
          onChange={handleInputChange}
        />
      </div>
      <div className='d-flex align-items-center gap-2'>
        <label htmlFor='end-date' className='form-label mb-1'>
          To:
        </label>
        <input
          type='date'
          id='end-date'
          className='form-control'
          value={localRange.end}
          onChange={handleInputChange}
          max={new Date().toISOString().split("T")[0]} // Prevent future dates
        />
      </div>
      <button className='btn btn-primary ms-2' onClick={handleApply}>
        Apply
      </button>
    </div>
  );
}

// Legacy quick-range buttons kept for reference; removed to satisfy no-lone-blocks ESLint rule.
